import { useNavigate } from "react-router-dom";
import {
  ArrowUpFromLine, ArrowDownToLine, FileSignature,
  Inbox, ArrowLeft, MessageCircle,
  Mailbox, Smartphone,
} from "lucide-react";
import { Badge } from "@/components/shared/Badge";
import { useBadgeCounts } from "@/hooks/useBadgeCounts";
import { TONE_BG } from "@/constants/tones";

// Batch #14.138 — `badgeKey` pour récupérer le compteur depuis useBadgeCounts.hubs.documents
const TILES = [
  { id: "sent",              label: "Envois",              desc: "Documents envoyés au client", icon: ArrowUpFromLine,  tone: "blue",    path: "/admin/documents/sent" },
  { id: "received",          label: "Dépôts",              desc: "Documents reçus du client",   icon: ArrowDownToLine,  tone: "indigo",  path: "/admin/documents/received",         badgeKey: "received" },
  { id: "client_documents",  label: "Documents à signer",  desc: "Envoyer un modèle PDF",       icon: FileSignature,    tone: "rose",    path: "/admin/client-documents",           badgeKey: "client-documents" },
  { id: "comms_hub",         label: "Suivi comms",         desc: "Notifications : envoyées · ouvertes · cliquées · signées", icon: Inbox,    tone: "emerald", path: "/admin/communications", badgeKey: "comms_stuck" },
  { id: "chat_clients",      label: "Chat clients",        desc: "Messagerie en direct",        icon: MessageCircle,    tone: "sky",     path: "/admin/questions",                  badgeKey: "questions" },
  // Batch #14.176 — Inbox réception DGFiscalFlow@dgcomptabilite.ca (lecture seule)
  { id: "inbox",             label: "Inbox",               desc: "Courriels reçus DGFiscalFlow", icon: Mailbox,         tone: "blue",    path: "/admin/inbox" },
  // Batch #14.229 — Boîte SMS Twilio (envoyés + reçus, conversations)
  // Batch #14.231 — Pastille SMS non lus (badgeKey sms_inbox)
  { id: "sms_inbox",         label: "Boîte SMS",           desc: "Textos envoyés & reçus (Twilio)", icon: Smartphone,   tone: "orange",  path: "/admin/sms-inbox",                  badgeKey: "sms_inbox" },
];


export default function DocumentsLauncher() {
  const navigate = useNavigate();
  const { counts } = useBadgeCounts();
  const hubBadges = counts?.hubs?.comms || {};
  return (
    <div className="max-w-4xl mx-auto px-4" data-testid="documents-launcher">
      <div className="flex items-center gap-3 mb-2">
        <button
          onClick={() => navigate("/admin")}
          className="w-9 h-9 rounded-full hover:bg-gray-100 flex items-center justify-center transition active:scale-90"
          aria-label="Retour au tableau de bord"
          data-testid="documents-back-btn">
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Centre de communications</h1>
      </div>
      <p className="text-sm text-gray-500 mb-8 ml-12">
        Selectionnez un module
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6">
        {TILES.map(t => {
          const badge = t.badgeKey ? (hubBadges[t.badgeKey] || 0) : 0;
          return (
            <button
              key={t.id}
              onClick={() => navigate(t.path)}
              className={`relative group bg-gradient-to-br ${TONE_BG[t.tone]} rounded-2xl p-5 sm:p-6 flex flex-col items-center justify-center text-center transition-all duration-200 transform hover:scale-105 active:scale-95 hover:shadow-lg border`}
              data-testid={`documents-tile-${t.id}`}>
              {badge > 0 && (
                <span className="absolute top-2 right-2">
                  <Badge count={badge} testid={`documents-badge-${t.id}`} />
                </span>
              )}
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white shadow-sm flex items-center justify-center mb-3 group-hover:shadow-md transition">
                <t.icon className="w-7 h-7 sm:w-8 sm:h-8" />
              </div>
              <span className="font-semibold text-sm sm:text-base mb-0.5">{t.label}</span>
              <span className="text-[10px] sm:text-xs opacity-75">{t.desc}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
